
export default {
  props: ["banner", "title"],
};
